// Suggested first questions, for the page the person is on. Each one is a
// question the assistant can answer from what it can read, worded the way a
// rep would ask it, so a tap is a real start and not a demo.

const LIST_PAGES = [
  {
    match: (p) => p === '/' || p.startsWith('/today'),
    starters: ["What's on my plate today?", 'Which accounts have gone quiet for a month?', "What's overdue, oldest first?"],
  },
  {
    match: (p) => p.startsWith('/opportunities'),
    starters: ['Pipeline by stage this quarter', 'Which deals close this month?', 'Which deals are past their close date?'],
  },
  {
    match: (p) => p.startsWith('/accounts'),
    starters: ['Which key accounts have had no activity in 30 days?', 'Which accounts have the most open pipeline?', 'Which accounts did I touch this week?'],
  },
  {
    match: (p) => p.startsWith('/action-items'),
    starters: ["What's overdue, oldest first?", "What's due this week?", 'Which action items have no due date?'],
  },
  {
    match: (p) => p.startsWith('/activities'),
    starters: ['What did I log this week?', 'Which meetings did I have this month?', 'Which accounts did I call this week?'],
  },
  {
    match: (p) => p.startsWith('/contacts'),
    starters: ['Who did I meet this month?', 'Which key contacts have I not spoken to in 60 days?', 'Who are the decision makers on my key accounts?'],
  },
];

const ANYWHERE = ["What's on my plate today?", 'Which deals close this month?', 'Which accounts have gone quiet for a month?'];

/**
 * Up to three questions for this page. `viewing` is the record the page is
 * about (its account, and a contact or deal when it is one); without it the
 * page's own list questions apply.
 */
export function startersFor({ pathname = '/', viewing = null } = {}) {
  if (viewing && viewing.opportunity_name) {
    const deal = viewing.opportunity_name;
    return [`Where does ${deal} stand, and what's the next step?`, `What could stall ${deal}?`, `Who have we talked to about ${deal}, and when?`];
  }
  if (viewing && viewing.contact_name) {
    const person = viewing.contact_name;
    return [`When did we last talk to ${person}, and about what?`, `What's open with ${person}?`, `What should I know before I call ${person}?`];
  }
  if (viewing && viewing.account_name) {
    const account = viewing.account_name;
    return [`What's the latest with ${account}?`, `What's open on ${account}: deals and action items?`, `Who at ${account} haven't we spoken to lately?`];
  }
  const page = LIST_PAGES.find((l) => l.match(pathname));
  return page ? page.starters : ANYWHERE;
}
